export const FacilityPermissionsEnum = {
  SELECTED: "SELECTED_FACILITIES",
  SELECT_ALL: "ALL_FACILITIES",
  SELECT_GROUPS: "SELECTED_FACILITY_GROUPS"
};
